export const COMMON_SET_COLORS: Record<string, string> = {
  GlobalRanking: '#00FFFF',
  newest: '#FFFF00',
  boosted: '#FF69B4',
  // Keep the following reserved for future use
  // CommonSet4: '#00FF00',
  // CommonSet5: '#FFA500',
}

export const DYNAMIC_COLORS = [
  '#1E90FF',
  '#FF1493',
  '#7FFFD4',
  '#FF00FF',
  '#00FA9A',
  '#FF4500',
  '#00CED1',
  '#FF6347',
  '#40E0D0',
  '#FFD700',
  '#00BFFF',
  '#FF8C00',
  '#7FFF00',
  '#DC143C',
  '#00FF7F',
  '#8A2BE2',
  '#FF69B4',
  '#32CD32',
  '#FF1493',
  '#00CED1',
]

export function getColorForSet(set: string, setToColorMap: Map<string, string>): string | undefined {
  // Check if already assigned
  if (setToColorMap.has(set)) {
    return setToColorMap.get(set)
  }

  // Assign common set color if available
  if (COMMON_SET_COLORS[set]) {
    const color = COMMON_SET_COLORS[set]
    setToColorMap.set(set, color)
    return color
  }

  // Find an available dynamic color
  const usedColors = new Set(setToColorMap.values())
  const availableColor = DYNAMIC_COLORS.find((color) => !usedColors.has(color))

  if (availableColor) {
    setToColorMap.set(set, availableColor)
    return availableColor
  }

  // If all colors are used, cycle through dynamic colors
  const index = setToColorMap.size % DYNAMIC_COLORS.length
  const color = DYNAMIC_COLORS[index]
  setToColorMap.set(set, color)
  return color
}
